'use strict';

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

module.exports = {
    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            var form = $(this);
            var button = $('.subscribe-contact-us');
            var url = form.attr('action');

            // components/appointment.js handles modal form on PDP
            if (form.closest('#appointment-modal').length) {
                return;
            }

            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            $.spinner().start();
            button.attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (data.success && data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });
    }
};
